<template>
  <div >
    <h1>This is an Settings page</h1>
    <p>Lang: {{lang}}</p>
    <p>v 30:01</p>
    <v-radio-group v-model="lang" :mandatory="true">
      <v-radio label="日本語/Japanese" value="ja-JP"></v-radio>
      <v-radio label="English" value="en-US"></v-radio>
    </v-radio-group>
  </div>
</template>
<script>
  import  { Logger } from 'aws-amplify';
  const logger = new Logger('Cart','INFO');
  import { AmplifyEventBus } from 'aws-amplify-vue'



  export default {
    created(){
      AmplifyEventBus.$on('cartCurrent',this.settingsFromCart)
    },
    beforeDestroy () {
       AmplifyEventBus.$off('cartCurrent',this.settingsFromCart )
    },
    mounted(){
      logger.info("Settings")
      AmplifyEventBus.$emit('getCart') // we don't need cart but settings inside cart data
      this.trackPage('/settings/')
      AmplifyEventBus.$emit('setJourney', {key:"page",value:"設定画面"} )
    },
    data(){
      return{
        lang:undefined,
      }
    },
    methods: {
      settingsFromCart: function (data) {
        this.lang = data.defalutSettings.defaultLang
      }
    },
    watch: {
      'lang': {
        handler: function (newVal) {
          //console.log("lang:" + newVal)
          AmplifyEventBus.$emit('langChanged',newVal)
        }
      },
    }
  }
  </script>